import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { db } from '../config/Firebase';
import { collection, query, getDocs } from 'firebase/firestore';

function RandomVisitor() {
  const navigate = useNavigate();
  const [visitors, setVisitors] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    const fetchRandomVisitors = async () => {
      setLoading(true);
      setError('');
      try {
        const visitorsCollection = collection(db, 'Visitors');
        const q = query(visitorsCollection);
        const querySnapshot = await getDocs(q);
        const allVisitors = querySnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));

        const shuffledVisitors = allVisitors
          .sort(() => Math.random() - 0.5)
          .slice(0, Math.min(10, allVisitors.length));

        setVisitors(shuffledVisitors);
      } catch (err) {
        setError('Failed to fetch visitors. Please try again.');
        console.error('Error:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchRandomVisitors();
  }, []);

  const handleVisitorClick = (email) => {
    navigate(`/VisitorDetails/${email}`);
  };

  return (
    <div className="min-h-screen bg-gray-50 p-8">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold text-gray-900 mb-2 tracking-tight border-b-2 border-black pb-2 inline-block px-8">VISITOR DIRECTORY</h2>
        </div>
        
        {loading && (
          <div className="flex justify-center items-center py-20">
            <div className="animate-pulse flex space-x-4">
              {[...Array(5)].map((_, i) => (
                <div key={i} className="bg-gray-200 rounded-full h-12 w-12 border-2 border-black"></div>
              ))}
            </div>
          </div>
        )}
        
        {error && (
          <div className="bg-white border-2 border-black text-gray-800 p-4 mb-8 rounded max-w-2xl mx-auto shadow-[4px_4px_0px_0px_rgba(0,0,0,1)]">
            <div className="flex items-center">
              <svg className="w-5 h-5 mr-2 text-gray-700" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
              <span>{error}</span>
            </div>
          </div>
        )}
        
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-6">
          {visitors.length === 0 && !loading && (
            <div className="col-span-full text-center py-12 border-2 border-black bg-white p-6 rounded-lg shadow-[4px_4px_0px_0px_rgba(0,0,0,1)]">
              <svg className="w-16 h-16 mx-auto text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1} d="M9.172 16.172a4 4 0 015.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
              <p className="mt-4 text-lg text-gray-600">No visitors found</p>
            </div>
          )}
          
          {visitors.map((visitor) => (
            <div
              key={visitor.id}
              className="bg-white p-5 rounded-lg border-2 border-black shadow-[4px_4px_0px_0px_rgba(0,0,0,1)] hover:shadow-[6px_6px_0px_0px_rgba(0,0,0,1)] hover:-translate-x-0.5 hover:-translate-y-0.5 transition-all duration-200 cursor-pointer group"
              onClick={() => handleVisitorClick(visitor.id)}
            >
              <div className="relative mb-4">
                {visitor.photo || visitor.imageUrl ? (
                  <img
  src={visitor.photo || visitor.imageUrl}
  alt={visitor.fullName || 'Visitor'}
  className="w-24 h-24 object-cover rounded-full mx-auto border-2 border-black shadow-md group-hover:border-gray-700 transition-colors duration-200"
/>
                ) : (
                  <div className="w-24 h-24 bg-gray-200 rounded-full mx-auto flex items-center justify-center text-gray-500 border-2 border-black shadow-md">
                    <svg className="w-10 h-10" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                    </svg>
                  </div>
                )}
                <div className="absolute bottom-0 right-0 bg-black text-white text-xs font-medium px-2 py-1 rounded-full border border-white">
                  NEW
                </div>
              </div>
              
              <h3 className="text-lg font-semibold text-gray-900 text-center mb-1 group-hover:text-black transition-colors duration-200">
                {visitor.fullName || 'Anonymous'}
              </h3>
              <p className="text-gray-500 text-center text-xs mb-3 truncate">
                {visitor.id}
              </p>
              
              <div className="flex justify-center">
                <span className="inline-block bg-white text-gray-800 text-xs px-3 py-1 rounded-full border-2 border-black group-hover:bg-black group-hover:text-white transition-colors duration-200">
                  VISITOR
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default RandomVisitor;